import type { EventContentObjectList } from 'models';
import { isProgramEventLive } from 'models';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import {
  CalendarLineIcon,
  Card,
  DataCardParticipants,
  DateTimeInfo,
  Flex,
  Image,
  Link,
  RadarLineIcon,
  Tag,
  Text,
} from 'ui';
import { images } from 'common/utils';

type P = {
  item: EventContentObjectList;
};

const EventContentObjectBody = ({ item }: P) => {
  const { t } = useTranslation();
  const { event } = item;
  const isLive =
    isProgramEventLive({ endTime: event.endTime, startTime: event.startTime }) && event.status === 'published';

  return (
    <Flex gap="ms" vertical>
      <Link to={routes.events.detail(event.nodeId ?? event.id)}>
        <Card.FullWidth>
          <Image
            alt={event.name}
            height={320}
            objectFit="cover"
            preview={false}
            src={event.coverPhoto?.url ?? images.default.eventCoverPhoto}
            width="100%"
          />
        </Card.FullWidth>
      </Link>
      <Link to={routes.events.detail(event.nodeId ?? event.id)}>
        <Flex gap="xs" vertical>
          <Flex gap="xs">
            <Tag color="pink" icon={<CalendarLineIcon />}>
              {t(event.eventType)}
            </Tag>
            {isLive ? (
              <Tag color="live" format={{ upperCase: true }} icon={<RadarLineIcon />}>
                Live
              </Tag>
            ) : null}
          </Flex>
          <Text type="title" weight="bold">
            {event.name}
          </Text>
          <DateTimeInfo timeInfo={{ dateFrom: event.startTime, dateTo: event.endTime }} />
          <DataCardParticipants
            participants={{
              count: event.goingInviteesCount,
              label: (formattedMembersCount) => t('{{invitees}} accepted', { invitees: formattedMembersCount }),
            }}
          />
        </Flex>
      </Link>
    </Flex>
  );
};

export default EventContentObjectBody;
